import RoomPreferences from "@mui/icons-material/RoomPreferences";
import EntityEdit from "./EntityEdit";
import EntityShow from "./EntityShow";
import EntitiesList from "./EntititesList";
import EntityCreate from "./EntityCreate";

export const entities = {
  list: EntitiesList,
  show: EntityShow,
  edit: EntityEdit,
  create: EntityCreate,
  icon: RoomPreferences,
  options: { label: "ra.entities.title" },
};
